/* 🤖 this file was generated by script */
export const wiconCircleNotch = {
  name: 'circle_notch',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.34 3.2a7 7 0 103.32 0"/></svg>`,
};
